define('addContentViewModel',['grasshopperModel'],
    function (GrasshopperModel) {
    'use strict';

    return GrasshopperModel.extend({});

});

